import React from "react";
import { Animated } from "react-native";
import { useShimmer } from "./useShimmer";

export interface ShimmerBoxProps {
  width?: number | string;
  height?: number;
  borderRadius?: number;
  style?: object;
}

const ShimmerBox: React.FC<ShimmerBoxProps> = ({ width = "100%", height = 16, borderRadius = 8, style }) => {
  const anim = useShimmer();

  const opacity = anim.interpolate({
    inputRange: [0, 1],
    outputRange: [0.45, 0.9],
  });

  return (
    <Animated.View
      style={[
        {
          width: width as any,
          height,
          borderRadius,
          backgroundColor: "#E2E8F0",
          opacity,
        },
        style,
      ]}
    />
  );
};

export default ShimmerBox;
